import { app } from '../../../../../app';

app.component('radiusProxyDownloadForm', {
    bindings: {
        action: '<',
        appType: '<',
    },
    templateUrl: require('./radius-proxy-download-form.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/app-integration-instructions/local/radius-proxy-download-form/radius-proxy-download-form.component.js